export const userTypeMap = {
  1: {
    nodeExecUsersName: 'person'
  },
  2: {
    nodeExecUsersName: 'department'
  },
  3: {
    nodeExecUsersName: 'role'
  },
  4: {
    nodeExecUsersName: 'bmDirector'
  },
  5: {
    nodeExecUsersName: 'zsDirector'
  }
};
export const nodeTypeMap = {
  // 发起人
  0: {
    defaultPermissionVal: 1
  },
  // 审核人
  1: {
    defaultPermissionVal: 2
  },
  // 抄送人
  2: {
    defaultPermissionVal: 2
  },
  // 办理人
  3: {
    defaultPermissionVal: 2
  }
};
